import * as PIXI from "pixi.js";
import Main from "../../../Main";
import HTPFirstPart from "../HTPFirstPart";
import TextureManager from "../../../managers/TextureManager";

const RED_ARROW_PATH = "./images/howtoplay/red_arrow.png";

export default class RedArrow extends PIXI.Sprite {
  private Main = Main.getInstance();
  private HTPFirstPart = HTPFirstPart.getInstance();
  targetY: number;
  startY: number;
  constructor() {
    super();
    this.addCoord();
    this.addTexture();
    this.addToCon();
  }
  addCoord() {
    const dim = this.Main.getDim();
    let _x = dim.width / 2 - 290;
    let _y = dim.height + 100;
    let _targetY = dim.height / 2 - 165;


    if (dim.width < dim.height) {
      _x = dim.width / 2 - 100;
      _y = dim.height + 200;
      _targetY = dim.height/2 - 450;
      this.rotation = Math.PI;
    }

    this.x = _x;
    this.y = _y;
    this.startY = _y;
    this.targetY = _targetY
  }
  addTexture() {
    const texture = TextureManager.getTexture(RED_ARROW_PATH);
    this.width = 150;
    this.height = 113;
    this.anchor.set(0, .5);
    this.texture = texture;
  }
  addToCon() {
    this.HTPFirstPart.addChild(this);
  }
}